var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('p',{staticClass:"product-name font-medium truncate"}),_c('p',{staticClass:"product-name font-medium truncate",style:({ color: _vm.getStatusColor(_vm.params) })},[_vm._v("\n\n      "+_vm._s(_vm.getName(_vm.params))+"\n       ")]),_c('p')])
}
var staticRenderFns = []

export { render, staticRenderFns }